
const SurveyError = () => {
    return (
        <>Error</>
    );
}

export default SurveyError;